// extracted by mini-css-extract-plugin
export default {"menuItem":"styles-module--menuItem--2pWMT","menuItemSelected":"styles-module--menuItemSelected--_IMFA"};